/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { hideHamburgerMenu, hideSearchForm } from './store/actions/menusActions';
import { showLogIn } from './store/actions/modalWindowsActions';
import Header from './Components/LandingPage/Header/Header';
import Footer from './Components/LandingPage/Footer/Footer';
import './App.scss';

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    isHamburgerMenuActive,
    isSearchFormActive,
  } = useSelector((state) => state.menus);

  const token = localStorage.getItem('AUTH_TOKEN');

  const clickHandler = () => {
    if (isHamburgerMenuActive) {
      dispatch(hideHamburgerMenu());
    }

    if (isSearchFormActive) {
      dispatch(hideSearchForm());
    }
  };

  useEffect(() => {
    if (location.pathname === '/personal_account/company_profile' && !token) {
      // navigate('/');
      // dispatch(showLogIn());
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <main
        className="main"
        aria-hidden="true"
        onClick={clickHandler}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
